export function enrichBasketMembers(basket, allClients) {
  if (!basket) return [];

  const clients = Array.isArray(allClients) ? allClients : [];
  const byId = new Map(clients.map((c) => [Number(c.id), c]));
  const byCode = new Map(
    clients.map((c) => [String(c.broker_client_code ?? "").trim(), c])
  );

  const links = basket.basket_clients;
  if (Array.isArray(links) && links.length > 0) {
    return links.map((row) => {
      const clientId = row.client_id != null ? Number(row.client_id) : null;
      const basketClientId = row.id ?? row.basket_client_id ?? null;
      const codeRaw = row.broker_client_code;
      const fromClient =
        (clientId != null && !Number.isNaN(clientId) ? byId.get(clientId) : null) ||
        (codeRaw != null ? byCode.get(String(codeRaw).trim()) : null);
      const broker_client_code =
        fromClient?.broker_client_code ?? (codeRaw != null ? String(codeRaw) : "—");

      const resolvedClientId =
        clientId != null && !Number.isNaN(clientId) ? clientId : fromClient?.id != null ? Number(fromClient.id) : null;
      return {
        basketClientId: basketClientId != null ? String(basketClientId) : null,
        clientId: resolvedClientId != null && !Number.isNaN(resolvedClientId) ? resolvedClientId : null,
        broker_client_code,
        canRemove: resolvedClientId != null && !Number.isNaN(resolvedClientId),
      };
    });
  }

  const codes = basket.broker_client_codes || [];
  return codes.map((code) => {
    const c = byCode.get(String(code).trim());
    const cid = c?.id != null ? Number(c.id) : null;
    return {
      basketClientId: null,
      clientId: cid != null && !Number.isNaN(cid) ? cid : null,
      broker_client_code: String(code),
      canRemove: cid != null && !Number.isNaN(cid),
    };
  });
}

export function memberClientIdSet(members) {
  const s = new Set();
  (members || []).forEach((m) => {
    if (m.clientId != null && !Number.isNaN(m.clientId)) s.add(m.clientId);
  });
  return s;
}
